import { render } from "./Examine.vue?vue&type=template&id=76aae052"
import script from "./Examine.vue?vue&type=script&lang=js"
export * from "./Examine.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__